export default "__VITE_ASSET__4c888ee8__"